export default __webpack_public_path__ + "static/media/masthead-he.368d97c5.png";